import { gameByID, gameCreate, gameDestroy, gameUpdate, gamesList } from '@/services/agency/showcaseGames.service'

export default {
	namespaced: true,
	state: {
		// SHOWCASES GAMES
		gamesList: {
			data: [],
			meta: {
				pagination: {
					total: 0,
				},
			},
		},
		game: {},
		// STATUS SHOWCASES GAMES
		gamesStatus: 'pending',
		gamesSaveStatus: 'init',
		gamesDeleteStatus: 'init',
	},
	getters: {
		// SHOWCASES GAMES
		getGamesList(state) {
			return state.gamesList
		},
		getGame(state) {
			return state.game
		},
		// SHOWCASES GAMES
		getGamesDeleteStatus(state) {
			return state.gamesDeleteStatus
		},
		getGamesSaveStatus(state) {
			return state.gamesSaveStatus
		},
		getGamesStatus(state) {
			return state.gamesStatus
		},
	},
	mutations: {
		// SHOWCASES GAMES
		GAMES_LIST(state, value) {
			state.gamesList = value
		},
		SET_GAME(state, value) {
			state.game = value
		},
		// STATUS SHOWCASES GAMES
		GAMES_STATUS(state, value) {
			state.gamesStatus = value
		},
		GAME_SAVE_STATUS(state, value) {
			state.gamesSaveStatus = value
		},
		GAME_DELETE_STATUS(state, value) {
			state.gamesDeleteStatus = value
		},
	},
	actions: {
		// SHOWCASES Games
		async fetchGameList({ commit }, params) {
			window.scrollTo({ top: 0, behavior: 'smooth' })
			commit('GAMES_STATUS', 'pending')
			commit('GAMES_LIST', {
				meta: {
					pagination: {
						total: 0,
					},
				},
			})
			try {
				const { data } = await gamesList(params)
				commit('GAMES_STATUS', 'init')
				commit('GAMES_LIST', data)
				return data
			} catch (error) {
				commit('GAMES_STATUS', 'init')
				throw error
			}
		},
		async fetchGameByID({ commit }, params) {
			commit('GAMES_STATUS', 'pending')
			try {
				const { data } = await gameByID(params)
				commit('GAMES_STATUS', 'init')
				commit('SET_GAME', data.data)
				return data
			} catch (error) {
				commit('GAMES_STATUS', 'init')

				return error
			}
		},
		async saveNewGame({ commit }, params) {
			commit('GAME_SAVE_STATUS', 'pending')
			try {
				const { data } = await gameCreate(params)
				commit('GAME_SAVE_STATUS', 'init')
				return data
			} catch (error) {
				commit('GAME_SAVE_STATUS', 'init')
				throw error
			}
		},
		async updateGame({ commit }, params) {
			commit('GAME_SAVE_STATUS', 'pending')
			try {
				const { data } = await gameUpdate(params)
				commit('GAME_SAVE_STATUS', 'init')
				return data
			} catch (error) {
				commit('GAME_SAVE_STATUS', 'init')
				throw error
			}
		},
		async deleteGameByID({ commit }, params) {
			commit('GAME_DELETE_STATUS', 'pending')
			try {
				const { data } = await gameDestroy(params)
				commit('GAME_DELETE_STATUS', 'init')
				return data
			} catch (error) {
				commit('GAME_DELETE_STATUS', 'error')

				return error
			}
		},
	},
}
